import { useEffect, useState } from "react";
import { IServiceCategory } from "../../services/api/ServiceCategory/types";
import { fetchServicesForAutocomplete } from "../../utils/fetchEntities";

const useFetchSearchServices = (search: string) => {
  const [services, setServices] = useState<IServiceCategory[]>([]);

  useEffect(() => {
    search.length > 0 &&
      fetchServicesForAutocomplete(search).then((response) =>
        setServices(response)
      );
  }, [search]);

  return { services };
};

export default useFetchSearchServices;
